import { Directive, TemplateRef, inject, input } from '@angular/core';
import { CellContextType } from '../models/table-context.model';

@Directive({ selector: '[fr8botUiTableCellDef]' })
export class TableCellDefUIDirective<DataType> {
  templateRef = inject<TemplateRef<CellContextType<DataType>>>(TemplateRef);

  readonly fr8botUiTableCellDef = input<DataType>();

  static ngTemplateContextGuard<DataType>(
    dir: TableCellDefUIDirective<DataType>,
    ctx: unknown,
  ): ctx is CellContextType<DataType> {
    return true;
  }
}
